import React, { useContext, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, useTheme } from "@mui/material";
import { GlobalContext } from "./Contexts";
import TicketLoadingStatus from "./TicketLoadingStatus";
import CloseIcon from "@mui/icons-material/CancelRounded";

export default function TicketLoadingDialogue(): JSX.Element {
    const context = useContext(GlobalContext);
    const theme = useTheme();
    const [isComplete, setIsComplete] = useState(false);

    function close() {
        context.setShowLoadingTicketsDialogue(false);
    }

    return (
        <Dialog open onClose={close}>
            <DialogTitle sx={{ textAlign: "center" }}>{isComplete ? "TICKETS LOADED FROM RPS" : "LOADING TICKETS FROM RPS"}</DialogTitle>
            <DialogContent>
                <TicketLoadingStatus pilot={context.proxyUser ?? context.loggedInUser} setIsComplete={setIsComplete} />
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <IconButton disabled={!isComplete} onClick={close} size={"large"} edge={"end"} sx={{ color: theme.palette.primary.main }}>
                    <CloseIcon fontSize={"large"} />
                </IconButton>
            </DialogActions>
        </Dialog>
    );
}
